module.exports = __webpack_public_path__ + "static/img/ydd-dy.89f64108.png";